import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

const SITE_URL = 'https://hs-india.com';
const SITE_NAME = 'HS India';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const SEO = ({ title, description, canonical, image, type }) => {
  // Build the canonical URL — prefer explicit prop, fall back to current path
  const canonicalUrl = canonical
    ? (canonical.startsWith('http') ? canonical : `${SITE_URL}${canonical}`)
    : typeof window !== 'undefined'
    ? window.location.href.split('?')[0].split('#')[0]
    : SITE_URL;

  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      {/* Core */}
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type || 'website'} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={ogImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

SEO.propTypes = {
  title:       PropTypes.string.isRequired,
  description: PropTypes.string,
  canonical:   PropTypes.string,   // absolute URL or path like "/about"
  image:       PropTypes.string,   // absolute URL to OG image
  type:        PropTypes.string,   // 'website' | 'article' | etc.
};

export default SEO;
